/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import dynamicHydrate from '@bluheadless/ui-logic/src/dynamic-hydration/dynamic-hydrate'
import EmptyIcon from '../icon/empty'

export * from './project-related-icons'
export const AccountFilledIcon = dynamicHydrate(() => import('./account-filled-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AccountFilledIconSvg = dynamicHydrate(
	() => import('./account-filled-icon').then((mod) => mod.AccountFilledIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AccountIcon = dynamicHydrate(() => import('./account-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AccountIconSvg = dynamicHydrate(() => import('./account-icon').then((mod) => mod.AccountIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AddFolderIcon = dynamicHydrate(() => import('./add-folder-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AddFolderIconSvg = dynamicHydrate(() => import('./add-folder-icon').then((mod) => mod.AddFolderIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArrowLeftIcon = dynamicHydrate(() => import('./arrow-left-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArrowLeftIconSvg = dynamicHydrate(() => import('./arrow-left-icon').then((mod) => mod.ArrowLeftIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArrowRightIcon = dynamicHydrate(() => import('./arrow-right-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArrowRightIconSvg = dynamicHydrate(
	() => import('./arrow-right-icon').then((mod) => mod.ArrowRightIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const ArrowheadDownIcon = dynamicHydrate(() => import('./arrowhead-down-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArrowheadDownIconSvg = dynamicHydrate(
	() => import('./arrowhead-down-icon').then((mod) => mod.ArrowheadDownIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const ArrowheadLeftIcon = dynamicHydrate(() => import('./arrowhead-left-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArrowheadLeftIconSvg = dynamicHydrate(
	() => import('./arrowhead-left-icon').then((mod) => mod.ArrowheadLeftIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const ArrowheadRightIcon = dynamicHydrate(() => import('./arrowhead-right-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArrowheadRightIconSvg = dynamicHydrate(
	() => import('./arrowhead-right-icon').then((mod) => mod.ArrowheadRightIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const ArrowheadUpIcon = dynamicHydrate(() => import('./arrowhead-up-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArrowheadUpIconSvg = dynamicHydrate(
	() => import('./arrowhead-up-icon').then((mod) => mod.ArrowheadUpIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const BadgeIcon = dynamicHydrate(() => import('./badge-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BadgeIconSvg = dynamicHydrate(() => import('./badge-icon').then((mod) => mod.BadgeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Bag1Icon = dynamicHydrate(() => import('./bag-1-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Bag1IconSvg = dynamicHydrate(() => import('./bag-1-icon').then((mod) => mod.Bag1IconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Bag2Icon = dynamicHydrate(() => import('./bag-2-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Bag2IconSvg = dynamicHydrate(() => import('./bag-2-icon').then((mod) => mod.Bag2IconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BookIcon = dynamicHydrate(() => import('./book-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BookIconSvg = dynamicHydrate(() => import('./book-icon').then((mod) => mod.BookIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BookmarkIcon = dynamicHydrate(() => import('./bookmark-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BookmarkIconSvg = dynamicHydrate(() => import('./bookmark-icon').then((mod) => mod.BookmarkIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CalendarIcon = dynamicHydrate(() => import('./calendar-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CalendarIconSvg = dynamicHydrate(() => import('./calendar-icon').then((mod) => mod.CalendarIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CameraIcon = dynamicHydrate(() => import('./camera-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CameraIconSvg = dynamicHydrate(() => import('./camera-icon').then((mod) => mod.CameraIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CardIcon = dynamicHydrate(() => import('./card-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CardIconSvg = dynamicHydrate(() => import('./card-icon').then((mod) => mod.CardIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CartIcon = dynamicHydrate(() => import('./cart-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CartIconSvg = dynamicHydrate(() => import('./cart-icon').then((mod) => mod.CartIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChatIcon = dynamicHydrate(() => import('./chat-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChatIconSvg = dynamicHydrate(() => import('./chat-icon').then((mod) => mod.ChatIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheckboxIndeterminateIcon = dynamicHydrate(() => import('./checkbox-indeterminate-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheckboxIndeterminateIconSvg = dynamicHydrate(
	() => import('./checkbox-indeterminate-icon').then((mod) => mod.CheckboxIndeterminateIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const CheckboxOffIcon = dynamicHydrate(() => import('./checkbox-off-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheckboxOffIconSvg = dynamicHydrate(
	() => import('./checkbox-off-icon').then((mod) => mod.CheckboxOffIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const CheckboxOnIcon = dynamicHydrate(() => import('./checkbox-on-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheckboxOnIconSvg = dynamicHydrate(
	() => import('./checkbox-on-icon').then((mod) => mod.CheckboxOnIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const CheckmarkCircleIcon = dynamicHydrate(() => import('./checkmark-circle-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheckmarkCircleIconSvg = dynamicHydrate(
	() => import('./checkmark-circle-icon').then((mod) => mod.CheckmarkCircleIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const CheckmarkIcon = dynamicHydrate(() => import('./checkmark-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheckmarkIconSvg = dynamicHydrate(() => import('./checkmark-icon').then((mod) => mod.CheckmarkIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ClockIcon = dynamicHydrate(() => import('./clock-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ClockIconSvg = dynamicHydrate(() => import('./clock-icon').then((mod) => mod.ClockIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CloudIcon = dynamicHydrate(() => import('./cloud-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CloudIconSvg = dynamicHydrate(() => import('./cloud-icon').then((mod) => mod.CloudIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CompassIcon = dynamicHydrate(() => import('./compass-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CompassIconSvg = dynamicHydrate(() => import('./compass-icon').then((mod) => mod.CompassIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Dashboard1Icon = dynamicHydrate(() => import('./dashboard-1-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Dashboard1IconSvg = dynamicHydrate(
	() => import('./dashboard-1-icon').then((mod) => mod.Dashboard1IconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const Dashboard2Icon = dynamicHydrate(() => import('./dashboard-2-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Dashboard2IconSvg = dynamicHydrate(
	() => import('./dashboard-2-icon').then((mod) => mod.Dashboard2IconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const DevicesIcon = dynamicHydrate(() => import('./devices-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DevicesIconSvg = dynamicHydrate(() => import('./devices-icon').then((mod) => mod.DevicesIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DislikeIcon = dynamicHydrate(() => import('./dislike-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DislikeIconSvg = dynamicHydrate(() => import('./dislike-icon').then((mod) => mod.DislikeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DownloadIcon = dynamicHydrate(() => import('./download-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DownloadIconSvg = dynamicHydrate(() => import('./download-icon').then((mod) => mod.DownloadIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EarthIcon = dynamicHydrate(() => import('./earth-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EarthIconSvg = dynamicHydrate(() => import('./earth-icon').then((mod) => mod.EarthIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EditIcon = dynamicHydrate(() => import('./edit-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EditIconSvg = dynamicHydrate(() => import('./edit-icon').then((mod) => mod.EditIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EmojiIcon = dynamicHydrate(() => import('./emoji-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EmojiIconSvg = dynamicHydrate(() => import('./emoji-icon').then((mod) => mod.EmojiIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EyeIcon = dynamicHydrate(() => import('./eye-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EyeIconSvg = dynamicHydrate(() => import('./eye-icon').then((mod) => mod.EyeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FileIcon = dynamicHydrate(() => import('./file-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FileIconSvg = dynamicHydrate(() => import('./file-icon').then((mod) => mod.FileIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FiltersIcon = dynamicHydrate(() => import('./filters-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FiltersIconSvg = dynamicHydrate(() => import('./filters-icon').then((mod) => mod.FiltersIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FingerprintIcon = dynamicHydrate(() => import('./fingerprint-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FingerprintIconSvg = dynamicHydrate(
	() => import('./fingerprint-icon').then((mod) => mod.FingerprintIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const FlashIcon = dynamicHydrate(() => import('./flash-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FlashIconSvg = dynamicHydrate(() => import('./flash-icon').then((mod) => mod.FlashIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FolderIcon = dynamicHydrate(() => import('./folder-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FolderIconSvg = dynamicHydrate(() => import('./folder-icon').then((mod) => mod.FolderIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FoldersIcon = dynamicHydrate(() => import('./folders-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FoldersIconSvg = dynamicHydrate(() => import('./folders-icon').then((mod) => mod.FoldersIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FullscreenCloseIcon = dynamicHydrate(() => import('./fullscreen-close-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FullscreenCloseIconSvg = dynamicHydrate(
	() => import('./fullscreen-close-icon').then((mod) => mod.FullscreenCloseIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const FullscreenOpenIcon = dynamicHydrate(() => import('./fullscreen-open-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FullscreenOpenIconSvg = dynamicHydrate(
	() => import('./fullscreen-open-icon').then((mod) => mod.FullscreenOpenIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const GiftIcon = dynamicHydrate(() => import('./gift-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GiftIconSvg = dynamicHydrate(() => import('./gift-icon').then((mod) => mod.GiftIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GlobeIcon = dynamicHydrate(() => import('./globe-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GlobeIconSvg = dynamicHydrate(() => import('./globe-icon').then((mod) => mod.GlobeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GridAlternateIcon = dynamicHydrate(() => import('./grid-alternate-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GridAlternateIconSvg = dynamicHydrate(
	() => import('./grid-alternate-icon').then((mod) => mod.GridAlternateIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const GridDefaultIcon = dynamicHydrate(() => import('./grid-default-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GridDefaultIconSvg = dynamicHydrate(
	() => import('./grid-default-icon').then((mod) => mod.GridDefaultIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const GridIcon = dynamicHydrate(() => import('./grid-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GridIconSvg = dynamicHydrate(() => import('./grid-icon').then((mod) => mod.GridIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HeartFilledIcon = dynamicHydrate(() => import('./heart-filled-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HeartFilledIconSvg = dynamicHydrate(
	() => import('./heart-filled-icon').then((mod) => mod.HeartFilledIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const HeartIcon = dynamicHydrate(() => import('./heart-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HeartIconSvg = dynamicHydrate(() => import('./heart-icon').then((mod) => mod.HeartIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HomeIcon = dynamicHydrate(() => import('./home-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HomeIconSvg = dynamicHydrate(() => import('./home-icon').then((mod) => mod.HomeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IdeaIcon = dynamicHydrate(() => import('./idea-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IdeaIconSvg = dynamicHydrate(() => import('./idea-icon').then((mod) => mod.IdeaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ImageIcon = dynamicHydrate(() => import('./image-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ImageIconSvg = dynamicHydrate(() => import('./image-icon').then((mod) => mod.ImageIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const InfoIcon = dynamicHydrate(() => import('./info-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const InfoIconSvg = dynamicHydrate(() => import('./info-icon').then((mod) => mod.InfoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LikeIcon = dynamicHydrate(() => import('./like-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LikeIconSvg = dynamicHydrate(() => import('./like-icon').then((mod) => mod.LikeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ListIcon = dynamicHydrate(() => import('./list-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ListIconSvg = dynamicHydrate(() => import('./list-icon').then((mod) => mod.ListIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LoadingIcon = dynamicHydrate(() => import('./loading-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LoadingIconSvg = dynamicHydrate(() => import('./loading-icon').then((mod) => mod.LoadingIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LockIcon = dynamicHydrate(() => import('./lock-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LockIconSvg = dynamicHydrate(() => import('./lock-icon').then((mod) => mod.LockIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MailIcon = dynamicHydrate(() => import('./mail-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MailIconSvg = dynamicHydrate(() => import('./mail-icon').then((mod) => mod.MailIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MailsIcon = dynamicHydrate(() => import('./mails-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MailsIconSvg = dynamicHydrate(() => import('./mails-icon').then((mod) => mod.MailsIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MapPinIcon = dynamicHydrate(() => import('./map-pin-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MapPinIconSvg = dynamicHydrate(() => import('./map-pin-icon').then((mod) => mod.MapPinIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Menu1Icon = dynamicHydrate(() => import('./menu-1-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Menu1IconSvg = dynamicHydrate(() => import('./menu-1-icon').then((mod) => mod.Menu1IconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Menu2Icon = dynamicHydrate(() => import('./menu-2-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Menu2IconSvg = dynamicHydrate(() => import('./menu-2-icon').then((mod) => mod.Menu2IconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Menu3Icon = dynamicHydrate(() => import('./menu-3-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Menu3IconSvg = dynamicHydrate(() => import('./menu-3-icon').then((mod) => mod.Menu3IconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MinusIcon = dynamicHydrate(() => import('./minus-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MinusIconSvg = dynamicHydrate(() => import('./minus-icon').then((mod) => mod.MinusIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MoonIcon = dynamicHydrate(() => import('./moon-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MoonIconSvg = dynamicHydrate(() => import('./moon-icon').then((mod) => mod.MoonIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MusicIcon = dynamicHydrate(() => import('./music-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MusicIconSvg = dynamicHydrate(() => import('./music-icon').then((mod) => mod.MusicIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NavigationIcon = dynamicHydrate(() => import('./navigation-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NavigationIconSvg = dynamicHydrate(
	() => import('./navigation-icon').then((mod) => mod.NavigationIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const NotificationsIcon = dynamicHydrate(() => import('./notifications-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NotificationsIconSvg = dynamicHydrate(
	() => import('./notifications-icon').then((mod) => mod.NotificationsIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const OptionsIcon = dynamicHydrate(() => import('./options-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const OptionsIconSvg = dynamicHydrate(() => import('./options-icon').then((mod) => mod.OptionsIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PauseIcon = dynamicHydrate(() => import('./pause-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PauseIconSvg = dynamicHydrate(() => import('./pause-icon').then((mod) => mod.PauseIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PlayIcon = dynamicHydrate(() => import('./play-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PlayIconSvg = dynamicHydrate(() => import('./play-icon').then((mod) => mod.PlayIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PlusIcon = dynamicHydrate(() => import('./plus-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PlusIconSvg = dynamicHydrate(() => import('./plus-icon').then((mod) => mod.PlusIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RadiobuttonOffIcon = dynamicHydrate(() => import('./radiobutton-off-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RadiobuttonOffIconSvg = dynamicHydrate(
	() => import('./radiobutton-off-icon').then((mod) => mod.RadiobuttonOffIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const RadiobuttonOnIcon = dynamicHydrate(() => import('./radiobutton-on-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RadiobuttonOnIconSvg = dynamicHydrate(
	() => import('./radiobutton-on-icon').then((mod) => mod.RadiobuttonOnIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const ResetIcon = dynamicHydrate(() => import('./reset-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ResetIconSvg = dynamicHydrate(() => import('./reset-icon').then((mod) => mod.ResetIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RocketIcon = dynamicHydrate(() => import('./rocket-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RocketIconSvg = dynamicHydrate(() => import('./rocket-icon').then((mod) => mod.RocketIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SearchIcon = dynamicHydrate(() => import('./search-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SearchIconSvg = dynamicHydrate(() => import('./search-icon').then((mod) => mod.SearchIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SecurityIcon = dynamicHydrate(() => import('./security-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SecurityIconSvg = dynamicHydrate(() => import('./security-icon').then((mod) => mod.SecurityIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SendIcon = dynamicHydrate(() => import('./send-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SendIconSvg = dynamicHydrate(() => import('./send-icon').then((mod) => mod.SendIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SettingsIcon = dynamicHydrate(() => import('./settings-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SettingsIconSvg = dynamicHydrate(() => import('./settings-icon').then((mod) => mod.SettingsIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ShareIcon = dynamicHydrate(() => import('./share-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ShareIconSvg = dynamicHydrate(() => import('./share-icon').then((mod) => mod.ShareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ShopIcon = dynamicHydrate(() => import('./shop-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ShopIconSvg = dynamicHydrate(() => import('./shop-icon').then((mod) => mod.ShopIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SoundIcon = dynamicHydrate(() => import('./sound-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SoundIconSvg = dynamicHydrate(() => import('./sound-icon').then((mod) => mod.SoundIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Stack1Icon = dynamicHydrate(() => import('./stack-1-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Stack1IconSvg = dynamicHydrate(() => import('./stack-1-icon').then((mod) => mod.Stack1IconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Stack2Icon = dynamicHydrate(() => import('./stack-2-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Stack2IconSvg = dynamicHydrate(() => import('./stack-2-icon').then((mod) => mod.Stack2IconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const StarEmptyIcon = dynamicHydrate(() => import('./star-empty-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const StarEmptyIconSvg = dynamicHydrate(() => import('./star-empty-icon').then((mod) => mod.StarEmptyIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const StarIcon = dynamicHydrate(() => import('./star-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const StarIconSvg = dynamicHydrate(() => import('./star-icon').then((mod) => mod.StarIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Statistics1Icon = dynamicHydrate(() => import('./statistics-1-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Statistics1IconSvg = dynamicHydrate(
	() => import('./statistics-1-icon').then((mod) => mod.Statistics1IconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const Statistics2Icon = dynamicHydrate(() => import('./statistics-2-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Statistics2IconSvg = dynamicHydrate(
	() => import('./statistics-2-icon').then((mod) => mod.Statistics2IconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const Statistics3Icon = dynamicHydrate(() => import('./statistics-3-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const Statistics3IconSvg = dynamicHydrate(
	() => import('./statistics-3-icon').then((mod) => mod.Statistics3IconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const SunIcon = dynamicHydrate(() => import('./sun-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SunIconSvg = dynamicHydrate(() => import('./sun-icon').then((mod) => mod.SunIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SupportIcon = dynamicHydrate(() => import('./support-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SupportIconSvg = dynamicHydrate(() => import('./support-icon').then((mod) => mod.SupportIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TagIcon = dynamicHydrate(() => import('./tag-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TagIconSvg = dynamicHydrate(() => import('./tag-icon').then((mod) => mod.TagIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TargetIcon = dynamicHydrate(() => import('./target-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TargetIconSvg = dynamicHydrate(() => import('./target-icon').then((mod) => mod.TargetIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TeamIcon = dynamicHydrate(() => import('./team-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TeamIconSvg = dynamicHydrate(() => import('./team-icon').then((mod) => mod.TeamIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TrashIcon = dynamicHydrate(() => import('./trash-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TrashIconSvg = dynamicHydrate(() => import('./trash-icon').then((mod) => mod.TrashIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UnlockIcon = dynamicHydrate(() => import('./unlock-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UnlockIconSvg = dynamicHydrate(() => import('./unlock-icon').then((mod) => mod.UnlockIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UploadIcon = dynamicHydrate(() => import('./upload-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UploadIconSvg = dynamicHydrate(() => import('./upload-icon').then((mod) => mod.UploadIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VideoCameraIcon = dynamicHydrate(() => import('./video-camera-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VideoCameraIconSvg = dynamicHydrate(
	() => import('./video-camera-icon').then((mod) => mod.VideoCameraIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const VideoIcon = dynamicHydrate(() => import('./video-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VideoIconSvg = dynamicHydrate(() => import('./video-icon').then((mod) => mod.VideoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VideosIcon = dynamicHydrate(() => import('./videos-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VideosIconSvg = dynamicHydrate(() => import('./videos-icon').then((mod) => mod.VideosIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WalletIcon = dynamicHydrate(() => import('./wallet-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WalletIconSvg = dynamicHydrate(() => import('./wallet-icon').then((mod) => mod.WalletIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const XCircleIcon = dynamicHydrate(() => import('./x-circle-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const XCircleIconSvg = dynamicHydrate(() => import('./x-circle-icon').then((mod) => mod.XCircleIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const XIcon = dynamicHydrate(() => import('./x-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const XIconSvg = dynamicHydrate(() => import('./x-icon').then((mod) => mod.XIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export * from './flagsround'
export * from './flagssquare'
export * from './payment_methods'
export * from './social'
export * from './washing'
